import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BuilderRequest } from 'src/app/models/requests';
import { ActorApiClient } from 'src/app/services/api-clients/actor.api-client';
import { EmailPreviewDialogComponent, EmailPreviewModalOptions } from '../email-preview-dialog/email-preview-dialog.component';
import { Is_ANY_Download_Action } from 'src/app/constants/actor-action.enum';

@Component({
  selector: 'app-reviewandsend',
  templateUrl: './reviewandsend.component.html'

})
export class ReviewandsendComponent implements OnInit {

  @Input('request') request!: BuilderRequest;
  @Output('currentStep') step = new EventEmitter<string>();
  @Output('openPDFViewer') openPDFViewer = new EventEmitter();
  active!: number;
  requestType!: string;

  constructor(private actorService: ActorApiClient, private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    if (this.request.actors.every(s => Is_ANY_Download_Action(s.action))) {
      this.requestType = "SecureSharing";
    } else {
      this.requestType = this.request.dossierType;
    }
  }

  async openEmailPreview(event: any) {
    let actor = this.request.actors.filter(item => item.dossierPersonId === event.actor.dossierPersonId && item.action)[0];
    if (actor && actor !== undefined) {
      (await this.actorService.getEmailTemplate(this.request.id, actor.id)).subscribe({
        next: (value: any) => {
          const modalRef = this.modalService.open(EmailPreviewDialogComponent, EmailPreviewModalOptions);
          modalRef.componentInstance.emailTemplate = value;
        }
      });
    }
  }
}
